module.exports = __webpack_public_path__ + "img/us-bg.3976462.png";